import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";

const ExtensionsList = Loadable(
  lazy(() =>
    import("./Extensions/ExtensionsList").then((module) => ({
      default: module.ExtensionsList,
    })),
  ),
);

const DidsList = Loadable(
  lazy(() =>
    import("./Dids/DidsList").then((module) => ({
      default: module.DidsList,
    })),
  ),
);

const CdrsList = Loadable(
  lazy(() =>
    import("./Cdrs/CdrsList").then((module) => ({
      default: module.CdrsList,
    })),
  ),
);

const QueuesList = Loadable(
  lazy(() =>
    import("./Queues/QueuesList").then((module) => ({
      default: module.QueuesList,
    })),
  ),
);

const PhoneBooksList = Loadable(
  lazy(() =>
    import("./PhoneBooks/PhoneBooksList").then((module) => ({
      default: module.PhoneBooksList,
    })),
  ),
);

const PhoneBookEntriesList = Loadable(
  lazy(() =>
    import("./PhoneBookEntries/PhoneBookEntriesList").then((module) => ({
      default: module.PhoneBookEntriesList,
    })),
  ),
);

const SimpleCdrsList = Loadable(
  lazy(() =>
    import("./SimpleCdrs/SimpleCdrsList").then((module) => ({
      default: module.SimpleCdrsList,
    })),
  ),
);

const ClickToCallPage = Loadable(
  lazy(() =>
    import("./ClickToCall/ClickToCallPage").then((module) => ({
      default: module.ClickToCallPage,
    })),
  ),
);

const IvrsList = Loadable(
  lazy(() =>
    import("./Ivrs/IvrsList").then((module) => ({
      default: module.IvrsList,
    })),
  ),
);

const VoicemailsList = Loadable(
  lazy(() =>
    import("./Voicemails/VoicemailsList").then((module) => ({
      default: module.VoicemailsList,
    })),
  ),
);

const FeatureCodesList = Loadable(
  lazy(() =>
    import("./FeatureCodes/FeatureCodesList").then((module) => ({
      default: module.FeatureCodesList,
    })),
  ),
);

const MediaFilesList = Loadable(
  lazy(() =>
    import("./MediaFiles/MediaFilesList").then((module) => ({
      default: module.MediaFilesList,
    })),
  ),
);

const ConditionsList = Loadable(
  lazy(() =>
    import("./Conditions/ConditionsList").then((module) => ({
      default: module.ConditionsList,
    })),
  ),
);

const HuntListsList = Loadable(
  lazy(() =>
    import("./HuntLists/HuntListsList").then((module) => ({
      default: module.HuntListsList,
    })),
  ),
);

const CustomDestinationsList = Loadable(
  lazy(() =>
    import("./CustomDestinations/CustomDestinationsList").then((module) => ({
      default: module.CustomDestinationsList,
    })),
  ),
);

export const phoneRoutes = [
  {
    path: "/phone/extensions",
    exact: true,
    element: <ExtensionsList />,
  },
  {
    path: "/phone/click-to-call",
    exact: true,
    element: <ClickToCallPage />,
  },
  {
    path: "/phone/dids",
    exact: true,
    element: <DidsList />,
  },
  {
    path: "/phone/cdrs",
    exact: true,
    element: <CdrsList />,
  },
  {
    path: "/phone/simple-cdrs",
    exact: true,
    element: <SimpleCdrsList />,
  },
  {
    path: "/phone/queues",
    exact: true,
    element: <QueuesList />,
  },
  {
    path: "/phone/phone-books",
    exact: true,
    element: <PhoneBooksList />,
  },
  {
    path: "/phone/phonebook-entries",
    exact: true,
    element: <PhoneBookEntriesList />,
  },
  {
    path: "/phone/ivrs",
    exact: true,
    element: <IvrsList />,
  },
  {
    path: "/phone/voicemails",
    exact: true,
    element: <VoicemailsList />,
  },
  {
    path: "/phone/media-files",
    exact: true,
    element: <MediaFilesList />,
  },
  {
    path: "/phone/feature-codes",
    exact: true,
    element: <FeatureCodesList />,
  },
  {
    path: "/phone/custom-destinations",
    exact: true,
    element: <CustomDestinationsList />,
  },
  {
    path: "/phone/hunt-lists",
    exact: true,
    element: <HuntListsList />,
  },
  {
    path: "/phone/conditions",
    exact: true,
    element: <ConditionsList />,
  },
];
